<template>
  <div class="our-work">
    <Header :imgUrl="require('@/assets/img/mission/03-sm.jpg')">
      <h1>¿Como lo logramos?</h1>
      <a
        class="primary-btn animated fadeIn delay-1s"
        href="#"
        v-scroll-to="{ el: '#content', offset: -90 }"
        >Ver Detalle</a
      >
    </Header>

    <div class="our-work__content" id="content">
      
      <section class="flex gap-2">
        <img class="our-work__text-image" :src="require('@/assets/img/que-hacemos.png')" />

        <section class="flex direction-column gap-1">
          <h2 class="our-work__headline full-width">¿Como lo logramos?</h2>
          <p class="our-work__text-content">
            <span>
              Mediante el desarrollo de proyectos, actividades que fortalezcan el desarrollo humano, 
              conscientes de que no es posible solos, realizamos alianzas, convenios y participamos en concursos, 
              siendo atento con la evolución, el cuidado preventivo de niños, niñas y adolescentes (NNA), 
              y el cuidado del medio ambiente, para el disfrute de sus derechos, vinculando a los padres como parte del proceso de formación, 
              así como las instituciones que interviene en su salud y educación formal.
            </span>
          </p>

          <h3>Objetivo misional</h3>
          <p class="our-work__text-content">
            Fortalecer la formación integral basada en la cultura, 
            en el marco de una atención individual, 
            desde un enfoque afectivo, 
            de inclusión social y con perspectiva emocional y artística, 
            que permita reforzar el desarrollo de competencias, el comportamiento, 
            las capacidades de creación de planes y proyectos de las familias colombianas y migrantes para que impulsen el desarrollo de su entorno y lleven una vida consciente y libre.
          </p>

          <h3>Objetivo general</h3>
          <p class="our-work__text-content">
            Participar en la formación y crecimiento de familias colombianas, migrantes, retornadas y población de acogida,  
            en condición de vulnerabilidad; a través de la exploración y comprensión del ser humano como un individuo capaz  de descubrir sus habilidades por medio de la cultura del arte, la tecnología y el manejo de emociones, 
            con el fin de formar personas con capacidad para la resolución de dificultades de forma flexible y creativa  (productiva) que aporten en la construcción de una sociedad equitativa e innovadora.
          </p>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";

export default {
  name: "OurAchievements",

  components: {
    Header
  },

  title() {
    return '¿Como lo logramos?';
  },
};
</script>

<style lang="scss" scoped>
.our-work {
  $root: &;

  &__content {
    width: 100%;
    max-width: 1024px;
    padding: 2rem 1rem;
    margin: 4rem auto;
    position: relative;
  }

  &__headline {
    padding: 0;
    font-size: 2.5rem;
  }

  &__text-content {
    line-height: 1.8;

    span {
      display: block;
      margin: 1rem 0 0;
    }
  }

  @media(max-width: 1024px) {
    #{$root}__text-image {
      position: absolute;
      top: 50%;
      left: 50%;
      opacity: .1;
      z-index: -1;
      transform: translate(-50%, -50%);
    }
  }

  @media(min-width: 1024px) {
    #{$root}__text-image {
      height: 100%;
    }
  }
}
</style>